module.exports = __webpack_public_path__ + "img/btn_skill.53a7cf1d.svg";